import locale from "localization/en";

export const bankDepositColumn = [
  { key: "depositId", text: locale.depositId },
  { key: "dateAndTime", text: locale.dateAndTime },
  { key: "amount", text: locale.amount },
  { key: "depositType", text: locale.depositType },
  { key: "remarks", text: locale.remarks },
  { key: "slipPreview", text: locale.slipPreview },
];
